import ParameterBinding from "views/logic/parameters/ParameterBinding";
const mergeParameterValues = (parameterValues, executionState) => {
  const { parameterBindings } = executionState;
  const parameterMap = parameterValues.map((value) => ParameterBinding.forValue(value)).toMap();
  return executionState.toBuilder().parameterBindings(parameterBindings.merge(parameterMap)).build();
};
export default mergeParameterValues;
